import { InjectedIntl } from 'react-intl';
import { action } from 'satcheljs';
import { RouteName } from '../store/store';

export const onCurrentRouteChanged = action(
  'onCurrentRouteChanged',
  (currentRoute: RouteName, formatMessage?: InjectedIntl['formatMessage']) => ({ currentRoute, formatMessage })
);
